import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Transport } from 'src/app/pages/custom-route/interfaces/custom-route.interface';
import { TransportIconComponent } from "./components/transport-icon/transport-icon.component";
import { TransportNameComponent } from "./components/transport-name/transport-name.component";
import { TransportDurationComponent } from "./components/transport-duration/transport-duration.component";
import { TransportStopDetailsComponent } from './components/transport-stop-details/transport-stop-details.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [
    TranslateModule,
    TransportIconComponent,
    TransportNameComponent,
    TransportDurationComponent,
    TransportStopDetailsComponent
],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MainComponent {
  public transportList = input<Transport[]>();
  public transportId = input<number | undefined>();
}
